import { DatePicker, Tooltip } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const toPolicyDay = (date) => {
  if (!date) return null;
  const parsed = dayjs(String(date).slice(0, 10));
  return parsed.isValid() ? parsed.startOf('day') : null;
};

const PublicHolidayDatePicker = ({
  publicHolidays,
  value,
  onChange,
  validFrom,
  validTo,
  disabledDate: disabledDateProp,
  ...props
}) => {
  const rangeStart = toPolicyDay(validFrom);
  const rangeEnd = toPolicyDay(validTo);
  const getHolidayForDate = (date) => {
    if (!date) return null;

    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    return publicHolidays.find(holiday =>
      dayjs(holiday.date).format('YYYY-MM-DD') === formattedDate
    );
  };

  const handleChange = (date) => {
    const holiday = getHolidayForDate(date);

    if (onChange) {
      onChange(date, holiday);
    }
  };

  const isWeekend = (date) => {
    const day = dayjs(date).day();
    return day === 0 || day === 6;
  };

  const isToday = (date) => {
    return dayjs(date).isSame(dayjs(), 'day');
  };

  const dateRender = (current) => {
    const holiday = getHolidayForDate(current);
    const weekend = isWeekend(current);
    const today = isToday(current);

    if (holiday || weekend || today) {
      const tooltipTitle = holiday
        ? holiday.name
        : weekend
          ? dayjs(current).day() === 0
            ? 'Sunday'
            : 'Saturday'
          : today
            ? 'Today'
            : '';


      return (
        <Tooltip title={tooltipTitle}>
          <div style={{
            // backgroundColor: '#f0f0f0', 
            backgroundColor: today ? '#fff1b8' : '#f0f0f0',
            // color: holiday ? 'red' : 'blue', 
            color: holiday ? 'red' : weekend ? 'blue' : today ? 'green' : 'inherit',
            borderRadius: '4px',
            border: today ? '1px solid #faad14' : 'none',
          }}>
            {current.date()}
          </div>
        </Tooltip>
      );
    }

    return <div>{current.date()}</div>;
  };

  const isOutsideValidity = (date) => {
    if (!date || (!rangeStart && !rangeEnd)) return false;
    const current = dayjs(date);
    if (rangeStart && current.isBefore(rangeStart, 'day')) return true;
    if (rangeEnd && current.isAfter(rangeEnd, 'day')) return true;
    return false;
  };

  const disabledDate = (current) => {
    if (isOutsideValidity(current)) return true;
    if (typeof disabledDateProp === 'function') return disabledDateProp(current);
    return false;
  };

  const today = dayjs().startOf('day');
  const defaultPickerValue = value
    ? dayjs(value)
    : rangeStart && today.isBefore(rangeStart, 'day')
      ? rangeStart
      : rangeEnd && today.isAfter(rangeEnd, 'day')
        ? rangeEnd
        : today;

  return (
    <DatePicker
      {...props}
      key={rangeStart || rangeEnd ? `${rangeStart?.format('YYYY-MM-DD')}-${rangeEnd?.format('YYYY-MM-DD')}` : 'open'}
      value={value}
      onChange={handleChange}
      dateRender={dateRender}
      minDate={rangeStart || undefined}
      maxDate={rangeEnd || undefined}
      disabledDate={rangeStart || rangeEnd || disabledDateProp ? disabledDate : undefined}
      defaultPickerValue={defaultPickerValue}
    />
  );
};

export default PublicHolidayDatePicker;
